import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { FaBook } from "react-icons/fa";
import { MdAccessTime } from "react-icons/md";
import { NavLink } from "react-router-dom";
import heroImg from "../components/assets/images/hero.png";
import heroImgback from "../components/assets/images/hero-shape-purple.png";
import { FaArrowDown } from "react-icons/fa";
import { FaUserGraduate } from "react-icons/fa";
import PopupAd from "../components/common/PopupAd";
import BookSlider from "./BookSlider";
import TestimonialPage from "./TestimonialPage";
import { IoEyeSharp } from "react-icons/io5";
import { FaRegBookmark } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa6";
import { PointerHighlight } from "../components/ui/pointer-highlight.tsx";

import { BsFillLightningChargeFill } from "react-icons/bs";
import { FaBookReader, FaGraduationCap, FaUsers } from "react-icons/fa";
import { About } from "./About";
import { Courses } from "./Courses";
import { Instructor } from "./Instructor";
import { Blog } from "./Blog";
import TopUsers from "./TopUsers/TopUsers";
import MyTeam from "./MyTeam";
import YouTubeSearch from "./YouTubeSearch";
import FreeJob from "./FreeJob/FreeJob";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./Home.css";
import bgphoto1 from "../components/assets/images/1.png"
import bgphoto2 from "../components/assets/images/2.png"
import bgphoto3 from "../components/assets/images/3.png"

const ITEMS_PER_PAGE = 6;
const slidesData = [
  {
    title: "‎ ",
    description: "",
    backgroundImage: `url(${bgphoto1})`, // Replace with your image paths
  },
  {
    title: "‎ ",
    // description: "hy sanju",
    backgroundImage: `url(${bgphoto2})`, // Replace with your image paths
  },
  {
    title: "‎ ",
    description: ">>>>>>>>>>>>>>>>>>>>",
    backgroundImage: `url(${bgphoto3})`, // Replace with your image paths
  },
];

export const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoSlideInterval, setAutoSlideInterval] = useState(null);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const [collegeName, setCollegeName] = useState("");
  const [collegeList, setCollegeList] = useState([]);

  // Handle search input change for College/University
  const handleCollegeInputChange = (e) => {
    setCollegeName(e.target.value);
    if (e.target.value) {
      fetchCollegeList(e.target.value);
    } else {
      setCollegeList([]);
    }
  };

  // Fetch College/University List based on search input
  const fetchCollegeList = async (name) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_COLLEGE_NAME}?college_name=${name}&limit=15`
      );
      const data = await response.json();
      setCollegeList(data);
    } catch (error) {
      // console.error("Error fetching college list:", error);
    }
  };

  // Handle selecting a College/University from the dropdown
  const handleCollegeSelect = (college) => {
    setCollegeName(college.College_Name);
    setLocation(college.College_Name)
    setCollegeList([]);

  };


  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.notesmania.in/get_search.php?search=${searchQuery}&category=${category}&college=${location}&limit=8&page=1`
      );
      const data = await response.json();
      setResults(data);
      setVisibleCount(ITEMS_PER_PAGE); // Show only the first 6 PDFs initially
    } catch (error) {
      // console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const showMore = () => {
    setVisibleCount((prev) => Math.min(prev + ITEMS_PER_PAGE, results.length));
  };


  // Handle item click to update views and navigate
  const handleClick = async (item) => {
    try {
      const response = await fetch(process.env.REACT_APP_UPDATE_VIEWS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      const data = await response.json();

      if (data.message === "View count updated successfully") {
        navigate(`/pdf/${item.id}`, {
          state: {
            pdfItem: item,
          },
        });
      } else {
        // console.error("Error updating view count: ", data.message);
      }
    } catch (err) {
      // console.error("Error updating view count: ", err);
    }
  };


  useEffect(() => {
    startAutoSlide();
    return () => {
      clearInterval(autoSlideInterval); // Cleanup interval on unmount
    };
  }, []);

  const updateSlide = (index) => {
    setCurrentSlide(index);
    resetAutoSlide();
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    resetAutoSlide();
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slidesData.length) % slidesData.length);
    resetAutoSlide();
  };

  const startAutoSlide = () => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    }, 9000); // Slower auto-slide: 5 seconds
    setAutoSlideInterval(interval);
  };

  const resetAutoSlide = () => {
    clearInterval(autoSlideInterval);
    startAutoSlide();
  };
  // console.log(results);


  return (
    <>
      {/* <div className="slider-wrapper">

        <div className="slider">
          {slidesData.map((slide, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{
                backgroundImage: slide.backgroundImage,
                backgroundSize: "cover",
                backgroundPosition: "center",
                opacity: index === currentSlide ? 1 : 0,
                visibility: index === currentSlide ? "visible" : "hidden",
              }}
            >

              <div className="slide-content">

                <h2 className="slide-title">{slide.title}</h2>
          
              </div>
            </div>

          ))}


        </div>

        


      </div> */}
      <div className="slider-wrapper">

        <BookSlider />
      </div>
      <section id="hero">
        <div className="container">
        <div className="heading text-center py-12">
  <h1 className="text-3xl font-semibold text-black">
    Why{" "}
    <PointerHighlight
 rectangleClassName=" border-blue-400"
 pointerClassName="text-red-500"
 containerClassName="inline-block bg-blue-200 "
    >
      NotesMania
    </PointerHighlight>{" "}
    Stands Out
  </h1>
  <span className="text-sm mt-2 block">
    You don't have to struggle alone, you've got our assistance and help.
  </span>
</div>

          <div className="search-wrapper">
            <form onSubmit={handleSearchSubmit} className="search-box">
              <div className="search-row flex justify-between gap-4">
                {/* Search by Keywords */}
                <div className="col-md-3">
                  <input

                    type="text"
                    className="search-input w-full py-2 px-4 border rounded-md"
                    placeholder="Search by Keywords..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div className="col-md-3">

                  <input
                    className="search-category w-full py-2 px-4 border rounded-md"
                    type="text"
                    id="collegeSearchInput"
                    placeholder="Type College Name"
                    value={collegeName}
                    onChange={handleCollegeInputChange}


                  />
                  {collegeList.length > 0 && (
                    <ul className="college-dropdown-home">
                      {collegeList.map((college, index) => (
                        <li key={index} onClick={() => handleCollegeSelect(college)}>
                          {college.College_Name}
                        </li>
                      ))}
                    </ul>
                  )}

                </div>

                {/* College Selection */}


                {/* Category Selection */}
                <div className="col-md-3">
                  <select
                    className="search-category w-full py-2 px-4 border rounded-md"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option value="">Select Category</option>
                    <option value="Notes">Notes</option>
                    <option value="Old_Paper">Old Paper</option>
                    <option value="Pdf">PDF</option>
                    {/* Add more categories as needed */}
                  </select>
                </div>

                {/* Search Button */}
                <div className="col-md-1">
                  <button
                    type="submit"
                    className="search-button py-2 px-4 bg-blue-600 text-white rounded-md cursor-pointer"
                  >

                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="container mx-auto mt-10">
        {loading && <p>Loading results...</p>}
        {!loading && results.length > 0 && (
          <div>
            <h2
              style={{
                textAlign: "center",
                marginBottom: "40px",
                fontSize: "20px",
              }}
            >
              Your Search Results
            </h2>
            <div className="grid grid-cols-3 gap-6 md:grid-cols-1">
              {results.slice(0, visibleCount).map((item) => (
                <div key={item.id} className="rounded-lg shadow-lg bg-white overflow-hidden transition-transform duration-300 hover:scale-105">
                  <div className="relative w-full h-64">
                    <img
                      src={item.image_path}
                      alt={item.title}
                      className="w-full h-full object-cover cursor-pointer hover:opacity-90"
                      onClick={() => handleClick(item)}
                    />
                    <div className="absolute top-3 left-3 flex gap-2">
                      <span className="text-xs bg-blue-700 px-3 py-1 text-white rounded-md shadow-md">
                        {item.subject || item.category}
                      </span>
                      <span className="text-xs bg-pink-700 px-3 py-1 text-white rounded-md shadow-md">
                        {item.course.includes("(")
                          ? item.course.match(/\(([^)]+)\)/)[1]
                          : item.course || "Trending"}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex justify-between text-gray-600 text-sm mb-2">
                      <div className="flex items-center gap-2">
                        <FaBook />
                        <span>{item.category}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <MdAccessTime className="text-orange-500" />
                        <span>{item.created_at.split(" ")[0]}</span>
                      </div>
                    </div>
                    <h3 className="text-lg font-semibold text-blue-600 mb-2 truncate">
                      {item.title.split(" ").slice(0, 10).join(" ")}{" "}
                      {item.title.split(" ").length > 10 ? "..." : ""}
                    </h3>
                    <p className="text-gray-700 text-sm mb-2 truncate">
                      {item.description.split(" ").slice(0, 7).join(" ")}{" "}
                      {item.description.split(" ").length > 7 ? "..." : ""}
                    </p>
                    <p className="text-gray-900 text-sm font-medium mb-2">
                      {item.college.split("(")[0].trim() || "Self-Registered User"}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-2">
                      {item.semester && (
                        <span className="text-xs bg-blue-700 px-3 py-1 text-white rounded-md shadow-md">
                          Semester: {item.semester}
                        </span>
                      )}
                      {item.year ? (
                        <span className="text-xs bg-pink-700 px-3 py-1 text-white rounded-md shadow-md">
                          Year: {item.year}
                        </span>
                      ) : (
                        item.tags?.split(",").map((tag, index) => (
                          <span
                            key={index}
                            className={`text-xs px-3 py-1 text-white rounded-md shadow-md ${index === 0 ? "bg-cyan-700" : index === 1 ? "bg-green-700" : "bg-red-700"
                              }`}
                          >
                            {tag}
                          </span>
                        ))
                      )}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <FaUserGraduate />
                      <NavLink to={`/profile/${item.username}`} className="hover:text-blue-500">
                        {item.username.length > 5 ? `${item.username.substring(0, 6)}...` : item.username}
                      </NavLink>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {visibleCount < results.length && (
              <div className="text-center mt-6">
                <button
                  onClick={showMore}
                  className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-blue-700 transition"
                >
                  Show More
                </button>
              </div>
            )}
          </div>



        )}
      </section>
      <About />
      <YouTubeSearch />
      <Courses />
      {/* <Quiz /> */}
      <FreeJob />
      <Instructor />
      <TestimonialPage />
      <Blog />
      <MyTeam />

    </>

  );
};
